import { useNavigate, useLocation } from 'react-router-dom';

import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

import logoLockupWhite from '#assets/images/logo-lockup-white.png';
import logoMark from '#assets/images/logo-mark.png';
import { useCreditsWallet } from '#creditFeature/models/credits/queries';
import { useAuth } from '#globalContexts/AuthProvider';
import { usePreferencesStore } from '#lib/stores/preferencesStore';
import { useUserSettings } from '#settingsFeature/models/userSettings/queries';

import NavItem from './NavItem';
import navItems, { adminNavItem } from './navItems';
import UserSection from './UserSection';

const Sidebar = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { user, signOut, capabilities: caps, isPlatformAdmin } = useAuth();
	const isCollapsed = usePreferencesStore((s) => s.sidebarCollapsed);
	const setIsCollapsed = usePreferencesStore((s) => s.setSidebarCollapsed);

	const { data: userSettings } = useUserSettings();

	const { data: wallet } = useCreditsWallet();

	const handleSignOut = async () => {
		try {
			await signOut();
			navigate('/login');
		} catch {
			// ignored
		}
	};

	const toggleSidebar = () => setIsCollapsed(!isCollapsed);

	return (
		<aside
			className={`bg-sidebar-gradient bg-no-repeat flex flex-col flex-shrink-0 h-full overflow-hidden transition-all duration-300 ${
				isCollapsed ? 'w-[72px]' : 'w-[260px]'
			}`}
		>
			<div
				className={`flex items-center border-b border-gray-600 flex-shrink-0 ${
					isCollapsed ? 'flex-col gap-2 p-4' : 'justify-between gap-3 p-5'
				}`}
			>
				<img
					src={isCollapsed ? logoMark : logoLockupWhite}
					alt="B2B Hero"
					className={isCollapsed ? 'w-8 h-8 flex-shrink-0' : 'h-8 w-auto min-w-0'}
				/>
				<button
					onClick={toggleSidebar}
					className="p-2 hover:bg-gray-700 rounded-lg transition-colors flex-shrink-0"
					title={isCollapsed ? 'Sidebar ausklappen' : 'Sidebar einklappen'}
				>
					{isCollapsed ? (
						<BsChevronRight className="w-4 h-4 text-bgBase-600" />
					) : (
						<BsChevronLeft className="w-4 h-4 text-bgBase-600" />
					)}
				</button>
			</div>

			{!isCollapsed && (
				<div className="text-xs uppercase mx-6 mt-5 mb-2 tracking-wider text-bgBase-600 flex-shrink-0">
					Navigation
				</div>
			)}

			<nav className={`flex flex-col px-3 flex-1 overflow-y-auto scrollbar-dark ${isCollapsed ? 'mt-5' : ''}`}>
				{(isPlatformAdmin ? [...navItems, adminNavItem] : navItems).map((item) => (
					<NavItem key={item.to} item={item} caps={caps} isCollapsed={isCollapsed} pathname={pathname} />
				))}
			</nav>

			<UserSection
				user={user}
				userSettings={userSettings}
				wallet={wallet}
				isCollapsed={isCollapsed}
				onSignOut={handleSignOut}
			/>
		</aside>
	);
};

export default Sidebar;
